import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ListItem from '../components/ListItem';
import { ResultsLoading } from '../components/Loading';

const Container = styled.div`
  background-color: white;
  margin-top: 60px;
  border-radius: 10px;
  box-sizing: border-box;
  height: 472px;
  overflow: auto;
`;

const SearchResults = ({
  loading,
  onClick,
  searchResultsValue
}) => (
  <Container>
    {
      loading && <ResultsLoading />
    }
    {
      searchResultsValue.length
        ? (
          <ListItem
            materials={searchResultsValue}
            onClick={onClick}
          />
        ) : null
    }
  </Container>
);

const mapStateToProps = (state) => ({
  searchResultsValue: state.wgw.wgwResultsValue
});

export default connect(mapStateToProps)(SearchResults);
